import AlbumPreview from '../cms/AlbumPreview';
import GalleryWidget from '../cms/GalleryWidget';
import {loadScript} from 'netlify-cms-lib-util';

// Fake page
export default function Admin() {
  return null;
}

loadAdmin();

async function loadAdmin() {
  // Don't run in node.js environments
  if (typeof document === 'undefined') return;

  // Only load on admin URL
  if (global.location.pathname !== '/admin/') return;

  // Don't re-init
  if (global._registeredAdmin) return;

  // Hide the public site mount point
  document.getElementById('root').style.display = 'none';
  global._registeredAdmin = true;

  // Load the CMS
  await loadScript('https://unpkg.com/netlify-cms@^2.0.0/dist/netlify-cms.js');

  GalleryWidget.initMediaLibrary();

  global.CMS.registerPreviewTemplate('albums', AlbumPreview);
  global.CMS.registerWidget('gallery', GalleryWidget);
}
